import { Theme } from '@material-ui/core';
import ThemeObject from '../utils/ThemeObject';
import { SET_THEME } from './ThemeCreator.action';

interface IThemeState {
    isLoading: boolean;
    theme: Theme | null;
    themeObject: ThemeObject | null;
}

/**Local Store for holding theme creation state */
export function ThemeCreatorReducer(state: IThemeState, action: { type: string; payload: any }) {
    switch (action.type) {
        case SET_THEME:
            const themeObject = new ThemeObject();
            // {
            //     primary: "#59408e",
            //     secondary: "#47518c",
            //     error: "#F52D5C",
            //     inputBackground: "#F3F4F9",
            //     inputFontColour: "#757575",
            //     paper: "#F3F4F9",
            //     infoText: "#F3F4F9"
            // }, {
            //     logo: "https://storage.googleapis.com/gd-wagtail-prod-assets/original_images/evolving_google_identity_2x1.jpg"
            // }
            return {
                ...state,
                theme: themeObject.createTheme(),
                themeObject: themeObject,
                isLoading: false,
            };
        default:
            return { ...state };
    }
}
